import { defineStore } from 'pinia'
import { ref, computed, watch, nextTick } from 'vue'

import axios from 'axios'
import dateFn from '@/mixins/date'

import {useConfig} from '@/stores/config'
import {useDevice} from '@/stores/device'
import {useLoader} from '@/stores/loader'

import { useRoute, useRouter } from 'vue-router';

export const useBooking = defineStore('booking', () => {

  const route = useRoute();
  const router = useRouter();
  const loaderStore = useLoader();
  const configStore = useConfig();
  const deviceStore = useDevice();

  const promo_code = ref('');
  const promo = ref(null); 
  const promo_status = ref(null); // null | 'success' | 'error' | 'expired'
  const promo_error_message = ref('');
  const promo_loading = ref(false);

  const appointment = ref(null)

  // appointment local data
  const step = computed(_ => configStore.config.booking_steps?.indexOf(route.name) != -1 ? route.name : null)

  const header_steps = computed(_ => {
    if(!configStore.config.booking_steps) return;

    const _steps = [];

    const step_service_index = configStore.config.booking_steps.indexOf('stepService');
    if(step_service_index != -1){
      _steps.push({
        name : 'stepService',
        label : 'Servizio',
        active : step_index.value >= step_service_index
      })
    }

    const step_team_index = configStore.config.booking_steps.indexOf('stepTeam');
    if(step_team_index != -1){
      _steps.push({
        name : 'stepTeam',
        label : 'Opzioni',
        active : step_index.value >= step_team_index
      })
    }

    const step_date_index = configStore.config.booking_steps.indexOf('stepDate');
    const step_booking_index = configStore.config.booking_steps.indexOf('booking');
    _steps.push({
      name : 'stepDate',
      label : 'Data',
      active : step_index.value >= step_date_index || step_index.index >= step_booking_index
    })

    const step_confirm_index = configStore.config.booking_steps.indexOf('confirm');
    _steps.push({
      name : 'confirm',
      label : 'Conferma',
      active : step_index.value >= step_confirm_index
    })

    return _steps;
  })
  const date_object = ref(null);

  const closed = ref(false);
  const slots = ref([])
  const id_selected_block = computed(_ => slots.value.length ? slots.value[0].id_slot_block : null);
  const start = ref(null)
  const end = ref(null)
  const service = ref(null);
  const service_bundle = ref(null);
  const service_or_bundle = computed(_=> service_bundle.value ? service_bundle.value : service.value);

  const is_paid = computed(_=>appointment.value.is_paid && appointment.value.booking_state === 'confirmed');
  const to_confirm = computed(_=>appointment.value.booking_state === 'to_confirm');

  const show_payment = computed(_=>{ return appointment.value?.confirmed_at === null && to_confirm.value})

  const services_team_users = ref({});

  const service_name = computed(_ => service_bundle.value ? service_bundle.value.name : (service.value ? service.value.name : null));
  const service_team_users = computed(_ => {
    const _service_team_users = [];
  
    if(service_bundle.value){
      for(const [id_service, id_team_user] of Object.entries(services_team_users.value)){
        const service = service_bundle.value.services.find(s => s.id == id_service);
        if(service){
          const team_user = service.users.find(s => s.id == id_team_user);
          if(team_user) _service_team_users.push(team_user);
        }
      }
      
    }else if(service.value){
      const id_team_user = services_team_users.value[service.value.id]
  
      if(id_team_user){
        const team_user = service.value.users?.find(s => s.id == id_team_user);
        if(team_user) _service_team_users.push(team_user);
      }
    }
    
    return _service_team_users;
  })

  watch(service, (value, oldValue) => {
    if(value) service_bundle.value = null;
  });

  watch(service_bundle, value => {
    if(value) service.value = null;
  });
  
  
  const note = ref('')
  const name = ref('')
  const phone = ref('')
  const email = ref('')

  const blocks = ref([])

  // --- B&B ---
  const checkin = ref(null)
  const checkout = ref(null)
  const bnb_availability = ref([])
  const availability_price_with_tax = ref(null)

  const today = new Date()
  const bnb_view_year = ref(today.getFullYear())
  const bnb_view_month = ref(today.getMonth() + 1)

  const bnb_nights = computed(_ => {
    if(!checkin.value || !checkout.value) return 0
    const diff = new Date(checkout.value) - new Date(checkin.value)
    return Math.round(diff / (1000 * 60 * 60 * 24))
  })
  // --- fine B&B ---

  watch([checkin, checkout], () => {
    availability_price_with_tax.value = null
  })

  var date_unwatch = null;

  async function getBookingConfirmed(){
    try{
      const response = await axios.get('/getBookingConfirmed/'+appointment.value.token)

      appointment.value = response.data.appointment
    }catch(e){
      console.error(e)
      if(e.response && e.response.status == 400 && e.response.data && e.response.data.message){
        errors.value = e.response.data.message
      } else throw e
    }
  }

  async function setAppointment(data){
    if(date_unwatch){
      date_unwatch();
      date_unwatch = null;
    }

    if(get_slots_unwatch){
      get_slots_unwatch();
      get_slots_unwatch = null;
    }

    appointment.value = data;
    deviceStore.appointment_token = appointment.value.token;

    note.value = appointment.value.note;

    promo_code.value = appointment.value.promo_code;
    promo.value = appointment.value.id_promo_code ? { code: appointment.value.promo_code } : null;
    promo_status.value = appointment.value.id_promo_code ? 'success' : null;
    promo_error_message.value = '';

    if(appointment.value.datetime_start && !appointment.value.is_multi_days) date_object.value = new Date(appointment.value.datetime_start.substring(0, 10));
    else date_object.value = new Date();

    if(appointment.value.is_multi_days){
      checkin.value = appointment.value.datetime_start?.substring(0, 10) ?? null;
      // checkout è datetime_end + 1 giorno (perché salvi -1 giorno a 23:59:59)
      checkout.value = appointment.value.datetime_end 
        ? dateFn.format_unix_date(new Date(new Date(appointment.value.datetime_end).getTime() + 86400000))
        : null;
    }

    if(appointment.value.service_bundle) service_bundle.value = appointment.value.service_bundle;
    else if(appointment.value.services && appointment.value.services.length) service.value = appointment.value.services[0];

    const preselected = new URLSearchParams(window.location.search).get('preselected_service');
    if(preselected && !appointment.value.confirmed && !['to_confirm', 'confirmed'].includes(appointment.value.booking_state)) {
      const preselected_service = configStore.config.services?.find(s => s.id == preselected);
      if(preselected_service) {
        service_bundle.value = null;
        service.value = preselected_service;

        // apsetta che vengano aggioranti tutti i dati e poi esegue il resto
        await nextTick();
        
        const stepServiceIndex = configStore.config.booking_steps.indexOf('stepService');
        const nextStep = configStore.config.booking_steps[stepServiceIndex + 1];
        
        if(nextStep){
          goNextToStep(nextStep);
          return;
        }
      }
    }

    if(!appointment.value.is_multi_days && appointment.value.datetime_start && appointment.value.datetime_end){
      start.value = dateFn.get_seconds_from_time(appointment.value.datetime_start.substring(11));
      end.value = dateFn.get_seconds_from_time(appointment.value.datetime_end.substring(11));
    }
  
    if(appointment.value.confirmed || appointment.value.booking_state === 'to_confirm' || appointment.value.booking_state === 'confirmed'){
      if(route.name != 'appointmentDetail'){
        return router.push('/'+configStore.account_slug+'/appointmentDetail?token=' + appointment.value.token)
      }
    }else{
      date_unwatch = watch(date_object, value => {
        appointment.value.datetime_start = dateFn.format_unix_date(value)+' 00:00:00';
        appointment.value.datetime_end = null;
      })

      if(step_index.value && step_index.value > step_reached_index.value) return router.push('/'+configStore.account_slug + '/' + step_reached.value + '?token=' + appointment.value.token);

      const team_step_index = configStore.config.booking_steps.indexOf('stepTeam');
      if(team_step_index != -1 && step_index.value == team_step_index && !services_with_team_selection.value.length){
        return goNextToStep(configStore.config.booking_steps[step_index.value+1]);
      }

      // getSlots or fallback unknown page
      if(['booking', 'confirm'].includes(step.value)) await getSlots();
      else if(!step.value) router.push('/'+configStore.account_slug + '/' + configStore.config.booking_steps[0] + '?token=' + appointment.value.token); // fallback to first step
    }
  }

  const day = computed({
    get() {
      return !appointment.value?.is_multi_days ? date_object.value?.getDate() : null;
    },
    set(value) {
      date_object.value.setDate(value)
      date_object.value = new Date(date_object.value)
    }
  })

  const day_formatted = computed(_ => day.value < 10 ? '0'+day.value : day.value);

  const month = computed({
    get() {
      return !appointment.value?.is_multi_days ? date_object.value?.getMonth()+1 : null;
    },
    set(value) {
      date_object.value.setMonth(value) - 1;
      date_object.value = new Date(date_object.value)
    }
  })

  const month_formatted = computed(_ => month.value < 10 ? '0'+month.value : month.value);

  const year = computed({
    get() {
      return !appointment.value?.is_multi_days ? date_object.value?.getFullYear() : null;
    },
    set(value) {
      date_object.value.setFullYear(value)
      date_object.value = new Date(date_object.value)
    }
  })

  const date = computed(_ => {
    if(appointment.value?.is_multi_days) return null; 
    
    var _month = month.value;
    if(_month<10) _month = '0' + _month;

    var _day = day.value;
    if(_day<10) _day = '0' + _day;

    return year.value +'-' + _month + '-'+ _day;
  })
  
  const optional_services_ids = computed(_ => {
    if(!service_or_bundle.value) return [];
    if(!service_or_bundle.value.optional_services) return [];
    
    return service_or_bundle.value.optional_services.filter(os => os.checked).map(os => os.id);
  })

  watch(optional_services_ids, () => {
    track();
  })
  
  const loading_slots = ref(true)

  function getOptionalServicePrice(os) {
    if (!os) return 0;
    if (os.billing_type === 'per_day') return (os.price_with_tax ?? 0) * (bnb_nights.value || 1);
    return os.price_with_tax ?? 0;
  }

  const is_finalized = computed(_ => {
    if(!appointment.value) return false;
    if(appointment.value.confirmed_at) return true;
    return ['to_confirm', 'confirmed'].includes(appointment.value.booking_state);
  })

  const price_with_tax = computed(_ => {
    if(!service_or_bundle.value?.show_prices) return null

    // da qui in poi il prezzo è un dato storico registrato a DB: non si ricalcola
    if(is_finalized.value && appointment.value?.price_with_tax != null){
      return appointment.value.price_with_tax
    }

    if(configStore.config.layout === 'layout_b&b'){
      if(!bnb_nights.value) return 0;

      var base_price = availability_price_with_tax.value != null
        ? availability_price_with_tax.value
        : (service_or_bundle.value.price_with_tax ?? 0) * bnb_nights.value

      var total = base_price

      if(service_or_bundle.value.optional_services){
        total += service_or_bundle.value.optional_services
          .filter(os => os.checked)
          .reduce((partialSum, os) => partialSum + getOptionalServicePrice(os), 0)
      }
      return total
    }

    const prices = slots.value.map(s => s.price_with_tax);
    if(!prices.length || !prices[0]) return 0;
  
    var total = prices.reduce((partialSum, a) => partialSum + a, 0);
  
    const discount = appointment.value?.total_discount_with_tax || 0;
    total -= discount;
    if(total < 0) total = 0;

    if(service_or_bundle.value.optional_services){
      total += service_or_bundle.value.optional_services
        .filter(os => os.checked)
        .reduce((partialSum, os) => partialSum + getOptionalServicePrice(os), 0);
    }
  
    return total;
  });

  const services_with_team_selection = computed(_ => {
    let _services = [...service_bundle.value ? service_bundle.value.services : (service.value ? [service.value] : [])];
    if(!_services.length) return [];

    _services = _services.filter(s => s.team_selection_enabled && s.users?.length > 1)

    for(const s of _services){
      s.team_users = [...s.users];

      if(!s.team_selection_required){
        s.team_users.unshift({
          id : -1,
          frontend_name : 'Nessuna preferenza'
        })
      }
    }

    return _services;
  })

  watch(services_with_team_selection, (value, oldValue) => {
    if(JSON.stringify(value.map(s => s.id)) == JSON.stringify(oldValue.map(s => s.id))) return; // check if old value and new value are equal

    services_team_users.value = {};
    for(const s of value){
      if(s.team_selection_required) services_team_users.value[s.id] = s.users[0].id;
      else{
        services_team_users.value[s.id] = -1;
      }
    }
  })

  const step_index = computed(_ => configStore.config.booking_steps?.indexOf(step.value));

  const step_reached = computed(_ => {
    var index_reached = 0;
    
    if(configStore.config.booking_steps.includes('stepService')){
      if(!service_or_bundle.value) return 'stepService';
      else index_reached++;
    }

    if(configStore.config.booking_steps.includes('stepTeam')){
      for(const s of services_with_team_selection.value){
        if(s.team_selection_required && typeof services_team_users[s.id] == 'undefined') return 'stepTeam';
      }
    
      index_reached++;
    }

    if(configStore.config.booking_steps.includes('stepDate')){
      /*if(appointment.value?.is_multi_days || !appointment.value.datetime_start) return 'stepDate';
      else */index_reached++;
    }

    if(configStore.config.layout === 'layout_b&b'){
      if(!checkin.value || !checkout.value) return 'booking';
      else index_reached++;
    }else{
      if(!start.value || !end.value) return 'booking';
      else index_reached++;
    }

    return configStore.config.booking_steps[index_reached];
  })

  const step_reached_index = computed(_ => configStore.config.booking_steps?.indexOf(step_reached.value));

  const next_enabled = computed(_ => step_reached_index.value > step_index.value);

  var get_slots_unwatch = null;

  async function getSlots(){
    if(configStore.config.layout === 'layout_b&b'){
      return await _getSlotsbnb();
    }else{
      return await _getSlotsStandard();
    }
  }

  async function _getSlotsbnb(){
    if(!service.value) return;

    loading_slots.value = true;

    const requested_year = bnb_view_year.value;
    const requested_month = bnb_view_month.value;

    const send_data = {
      token : appointment.value.token,
      year : requested_year,
      month : requested_month,
      id_service : service.value.id,
    }

    try{
      const response = await axios.put('/slots', send_data)

      // scarta la risposta se nel frattempo il mese visualizzato è cambiato
      if(requested_year !== bnb_view_year.value || requested_month !== bnb_view_month.value) return;

      bnb_availability.value = response.data.availability ?? [];
      if(response.data.service){
        if(response.data.service.id !== service.value?.id) service.value = response.data.service;
        else service.value.optional_services = response.data.service.optional_services;
      }

    }catch(e){
      console.log(e);
      bnb_availability.value = [];
      if(e.response && e.response.status == 400 && e.response.data && e.response.data.message){
        errors.value = e.response.data.message
      } else throw e
    }

    loading_slots.value = false;
  }

  async function _getSlotsStandard(){
    if(!date.value) return;
    if(!service_or_bundle.value) return;

    loading_slots.value = true;

    const send_data = {
      step : step.value,
      date : date.value,
      start : start.value,
      end : end.value,
      token : appointment.value.token,
      services_team_users : services_team_users.value
    }
    if(service_bundle.value) send_data.id_service_bundle = service_bundle.value.id;
    else send_data.id_service = service.value?.id;

    try{
      const response = await axios.post('/slots', send_data)
  
      slots.value.splice(0);

      closed.value = response.data.closed ? response.data.closed : false;
      if(response.data.blocks && !response.data.blocks.length){
        blocks.value.splice(0);
        closed.value = {
          type : 'late',
          message : 'Disponibilità terminate.'
        };
      } else{
        if(response.data.blocks) blocks.value = response.data.blocks;

        if(response.data.service_bundle) service_bundle.value = response.data.service_bundle;
        else if(response.data.service) service.value = response.data.service;

        if(start.value && end.value){
          const _start = start.value;
          const _end = end.value;
          
          const selected_block = blocks.value.find(b => b.start <= _start && b.end >= _end);
          if(selected_block){
            for(const index in selected_block.slots){
              const slot = selected_block.slots[index];
              if(_start <= slot.start && _end >= slot.end){
                addSlot(parseInt(index), selected_block.slots[index])
              }
            }
          }

          if(!slots.value.length){
            start.value = 0;
            end.value = null;
            
            goBackToStep('booking');
          }
        }
      }
      
    }catch(e){
      console.log(e);

      blocks.value.splice(0);
      slots.value.splice(0);
      start.value = 0;
      end.value = null;

      goBackToStep('booking');
      if(e.response && e.response.status == 400 && e.response.data && e.response.data.message){
        errors.value = e.response.data.message
      } else throw e
      // TODO error
    }
    loading_slots.value = false;
    
    if(!get_slots_unwatch) get_slots_unwatch = watch([date_object], _getSlotsStandard);
  }

  // quando cambia il mese nel picker B&B, ricarica la disponibilità
  watch([bnb_view_year, bnb_view_month], () => {
    if(configStore.config.layout === 'layout_b&b') _getSlotsbnb();
  })

  watch(slots, value => {
    var _start = 999999;
    var _end = 0;

    for(const s of value){
      if(s.start < _start) _start = s.start;
      if(s.end > _end) _end = s.end;
    }

    if(_start == 999999 || _end == 0){
      _start = 0;
      _end = null;
    }
    
    start.value = _start;
    end.value = _end;
  }, {
    deep : true
  })

  const slots_index_sequence = ref([]);
  function removeSlot(index_to_remove){
    slots.value.splice(slots_index_sequence.value.indexOf(index_to_remove), 1);
    slots_index_sequence.value.splice(slots_index_sequence.value.indexOf(index_to_remove), 1)
  
    if(slots.value.length > 1){
      const start_index = slots_index_sequence.value[0];
      for(let i=1; i<slots_index_sequence.value.length; i++){
        if(start_index+i != slots_index_sequence.value){
          slots.value.splice(0)
          slots_index_sequence.value.splice(0)
          break;
        }
      }
    }
  }

  function addSlot(index_to_add, slot_to_add){
    if(!slots.value.length){
      slots.value.push(slot_to_add)
      slots_index_sequence.value.push(index_to_add)
      return;
    }
  
    if(service_bundle.value || !service.value.book_adjacent_slots_enabled || slot_to_add.id_slot_block != slots.value[0].id_slot_block){
      slots.value.splice(0)
      slots.value.push(slot_to_add)
  
      slots_index_sequence.value.splice(0)
      slots_index_sequence.value.push(index_to_add)
      return;
    }
  
    var sequence_index = 0;
    if(index_to_add != slots_index_sequence.value[0]-1 && index_to_add != slots_index_sequence.value[slots_index_sequence.value.length-1]+1){
      slots.value.splice(0)
      slots_index_sequence.value.splice(0)
    }else if(index_to_add == slots_index_sequence.value[slots_index_sequence.value.length-1]+1) sequence_index = slots_index_sequence.value.length;
  
    slots.value.splice(sequence_index, 0, slot_to_add)
    slots_index_sequence.value.splice(sequence_index, 0, index_to_add)
  }

  async function track(){
    if(!appointment.value) return;
    if(appointment.value.booking_state === 'to_confirm') return;
    if(appointment.value.booking_state === 'confirmed') return;
    if(appointment.value.confirmed_at !== null && appointment.value.confirmed_at !== undefined) return;

    if(configStore.config.layout === 'layout_b&b'){
      return await _track_bnb();
    }else{
      return await _track_standard();
    }
  }

  async function _track_bnb() {
    const send_data = {
      step: step.value,
      start_date: checkin.value,
      end_date: checkout.value,
      token: appointment.value?.token,
      optional_services_ids : optional_services_ids.value,
      id_service: service.value?.id,
      note : note.value,
      phone : phone.value,
      email : email.value,
    }

    try{
      const response = await axios.post('/track', send_data)
      availability_price_with_tax.value = response.data.price_with_tax

      if(response.data.total_service_with_tax !== undefined){
        appointment.value.total_service_with_tax = response.data.total_service_with_tax;
        appointment.value.total_discount_with_tax = response.data.total_discount_with_tax;
      }

      if(response.data.promo_code === null && promo.value){
        promo.value = null;
        promo_code.value = null;
        promo_status.value = 'expired';
        promo_error_message.value = 'Il codice sconto non è più valido per la data selezionata';
        appointment.value.promo_code = null;
        appointment.value.id_promo_code = null;
      }
    }catch(e){
      if(e.response?.status == 409){
        // reset date e torna al calendario
        checkin.value = null
        checkout.value = null
        availability_price_with_tax.value = null
      }
      console.error(e)
      if(e.response && e.response.status == 400 && e.response.data && e.response.data.message){
        errors.value = e.response.data.message
      } else throw e
    }
  }
  
  async function _track_standard(){
    const send_data = {
      step : step.value,
      date : date.value,
      start : start.value,
      end : end.value,
      token : appointment.value.token,
      services_team_users : services_team_users.value,
      id_selected_block : id_selected_block.value,
      optional_services_ids : optional_services_ids.value,
      note : note.value,
      phone : phone.value,
      email : email.value,
    };

    if(service_bundle.value) send_data.id_service_bundle = service_bundle.value.id;
    else{
      send_data.id_service = service.value?.id;
      if(service.value) send_data.slots_ids = slots.value.map(s => s.id);
    }

    try{
      const response = await axios.post('/track', send_data)

      if(response.data.price_with_tax !== undefined){
        appointment.value.price_with_tax = response.data.price_with_tax;
        appointment.value.total_service_with_tax = response.data.total_service_with_tax;
        appointment.value.total_discount_with_tax = response.data.total_discount_with_tax;
      }

      if(response.data.promo_code === null && promo.value){
        promo.value = null;
        promo_code.value = null;
        promo_status.value = 'expired';
        promo_error_message.value = 'Il codice sconto non è più valido per la data selezionata';
        appointment.value.promo_code = null;
        appointment.value.id_promo_code = null;
      }
    }catch(e){
      console.error(e)
      if(e.response && e.response.status == 400 && e.response.data && e.response.data.message){
        errors.value = e.response.data.message
      } else throw e
    }
  }

  async function confirm(extra_data){
    if(configStore.config.layout === 'layout_b&b') return await _confirm_bnb(extra_data)
    else return await _confirm_standard(extra_data)
  }

  async function _confirm_bnb(extra_data){
    var send_data = {
      start_date: checkin.value,
      end_date: checkout.value,
      // price_with_tax: price_with_tax.value,
      note: note.value,
      phone: phone.value,
      email: email.value,
      name: name.value,
      optional_services_ids: optional_services_ids.value,
      id_service: service.value?.id,
    }

    if(extra_data) send_data = {...send_data, ...extra_data}

    try{
      const response = await axios.post('/appointment/'+appointment.value.token+'/confirm', send_data)
      await setAppointment(response.data.appointment);
    }catch(e){
      if(e.response?.data?.promo_status){
        promo_status.value = e.response?.data?.promo_status;
        promo.value = null;
        promo_code.value = null;
        promo_error_message.value = e.response?.data?.message;
      }
      else if(e.response?.status == '409' && e.response?.data?.status == 'unavailable'){
        return goBackStep();
      }
      else throw e;
    }
  }

  async function _confirm_standard(extra_data){
    var send_data = {
      date : dateFn.format_unix_date(date.value),
      start : start.value,
      end : end.value,
      services_team_users : services_team_users.value,
      id_selected_block : id_selected_block.value,      
      // price_with_tax : price_with_tax.value,
      note : note.value,
      phone : phone.value,
      email : email.value,
      name : name.value,
      optional_services_ids : optional_services_ids.value,
    }
  
    if(service_bundle.value) send_data.id_service_bundle = service_bundle.value.id;
    else{
      send_data.id_service = service.value.id;
      send_data.slots_ids = slots.value.map(s => s.id);
    }

    if(extra_data) send_data = {...send_data, ...extra_data}
  
    try{
      const response = await axios.post('/appointment/'+appointment.value.token+'/confirm', send_data)
      await setAppointment(response.data.appointment);

    }catch(e){
      if(e.response?.status == '409' && e.response?.data?.status == 'unavailable'){
        console.log('mi dispiace!');
        return goBackStep();
      }else throw e;
    }
  }

  async function applyPromo(){
    promo_loading.value = true;

    await track();

    try{
      const response = await axios.post('/appointment/'+appointment.value.token+'/applyPromo', {
        promo_code : promo_code.value,
      });

      promo_status.value = response.data.promo_status;
      promo.value = response.data.status === 'success' ? response.data.promo : null;

      if(response.data.price_with_tax !== undefined){
        appointment.value.price_with_tax = response.data.price_with_tax;
        appointment.value.total_service_with_tax = response.data.total_service_with_tax;
        appointment.value.total_discount_with_tax = response.data.total_discount_with_tax;
        appointment.value.promo_code = promo.value?.code;
        appointment.value.id_promo_code = promo.value?.id;
      }

      await track();

    }catch(e){
      if(e.response.data?.message?.promo_code){
        promo_status.value = 'error';
        promo.value = null;
        promo_code.value = null;
        promo_error_message.value = e.response?.data?.message;
      }else throw e
    }finally{
      promo_loading.value = false;
    }

    return { status : promo_status.value };
  }

  async function removePromo(){
    promo_loading.value = true;

    try{
      const response = await axios.post('/appointment/'+appointment.value.token+'/removePromo');

      if(response.data.price_with_tax !== undefined){
       appointment.value.price_with_tax = response.data.price_with_tax;
        appointment.value.total_service_with_tax = response.data.total_service_with_tax;
        appointment.value.total_discount_with_tax = response.data.total_discount_with_tax;
        appointment.value.promo_code = null;
        appointment.value.id_promo_code = null;
      }
    }catch(e){
      console.error(e)
      if(e.response && e.response.status == 400 && e.response.data && e.response.data.message){
        errors.value = e.response.data.message
      } else throw e
    }finally{
      promo_code.value = null;
      promo.value = null;
      promo_status.value = null;
      promo_loading.value = false;
    }

    await track();
  }
  
  async function newAppointment(){
    
    loaderStore.open();
    try{
      const response = await axios.post('/appointment/'+appointment.value.token+'/newAppointment')

      if(response.data.device_token){
        deviceStore.device_token = response.data.device_token;
        axios.defaults.headers.PrenotAIDeviceToken = deviceStore.device_token;
      }

      await setAppointment(response.data.appointment);

      start.value = 0;
      end.value = null;

      await router.push('/'+configStore.account_slug + '/' +  configStore.config.booking_steps[0] + '?token=' + appointment.value.token)
      
    }catch(e){
      console.error(e)
      if(e.response && e.response.status == 400 && e.response.data && e.response.data.message){
        errors.value = e.response.data.message
      } else throw e
    }

    loaderStore.close();
  }

  function goBackStep(){
    var new_index = step_index.value - 1;
    if(typeof configStore.config.booking_steps[new_index] !== 'undefined'){
      
      goBackToStep(configStore.config.booking_steps[new_index]);
    }
  }

  function goBackToStep(new_step){
    var new_index = configStore.config.booking_steps.indexOf(new_step);
    if(new_index == -1 || new_index >= step_index.value) return;

    if(new_step == 'booking') getSlots();
    else if(new_step == 'stepTeam' && !services_with_team_selection.value.length) return goBackToStep(configStore.config.booking_steps[new_index-1]);
    else if(get_slots_unwatch){
      get_slots_unwatch();
      get_slots_unwatch = null;
    }

    router.push('/'+configStore.account_slug+'/' + configStore.config.booking_steps[new_index] + '?token=' + appointment.value.token);
    track();
  }

  function goNextStep(){
    var new_index = step_index.value + 1;
    if(typeof configStore.config.booking_steps[new_index] == 'undefined') return;
    
    if(configStore.config.booking_steps[new_index] == 'stepTeam' && !services_with_team_selection.value.length){
      return goNextToStep(configStore.config.booking_steps[new_index+1]);
    }

    return goNextToStep(configStore.config.booking_steps[new_index]);
  }

  function goNextToStep(new_step){
    var new_index = configStore.config.booking_steps.indexOf(new_step);
    if(new_index == -1) return;

    if(configStore.config.booking_steps[new_index] == 'booking') getSlots();

    router.push('/'+configStore.account_slug+'/' + configStore.config.booking_steps[new_index] + '?token=' + appointment.value.token);
  }

  watch(_ => route.name, value => {
    if(value && configStore.config.booking_steps && configStore.config.booking_steps?.indexOf(value) != -1) track();
  })

  return {
    header_steps,
    step,
    step_index,
    step_reached,
    step_reached_index,
    next_enabled,

    appointment,
    date_object,
    date,
    day,
    day_formatted,
    month,
    month_formatted,
    year,
    start,
    end,
    service,
    service_bundle,
    service_or_bundle,
    optional_services_ids,
    note,
    phone,
    email,
    is_paid,
    to_confirm,
    show_payment,
    name,
    price_with_tax,
    slots,
    blocks,
    id_selected_block,
    
    services_with_team_selection,
    services_team_users,
    loading_slots,
    closed,

    service_name,
    service_team_users,

    // B&B
    checkin,
    checkout,
    bnb_availability,
    bnb_view_year,
    bnb_view_month,
    bnb_nights,

    promo_code,
    promo,
    promo_status,
    promo_loading,
   
    getSlots,
    track,
    setAppointment,
    confirm,
    newAppointment,
    goNextStep,
    goBackStep,
    goBackToStep,
    getBookingConfirmed,
    getOptionalServicePrice,

    applyPromo,
    removePromo,

    slots_index_sequence,
    removeSlot,
    addSlot
  }

})